import React from 'react';

import Typography from '@material-ui/core/Typography';
import ResourceLabel from './ResourceLabel';
import ResourceValue from './ResourceValue';
import { withStyles } from '@material-ui/core';

/**
 * View of a single resource usage, with resource id, progress and used/total
 */

const styles = theme => ({
  captionColor: {
    color: '#A1A1A1'
  }
});

const ResourceUsage = ({resource, classes}) => {
  return (
          <div style={{display:'flex', flexDirection:'column', alignItems:'flex-start'}} >
            <Typography align="center" variant="caption" className={classes.captionColor}>
              <ResourceLabel resource={resource} />
            </Typography>
          
            <Typography align="center">
              <ResourceValue 
                resource={resource}
                value={resource.limit} 
                displayUnit
                displayLimit
                displayValue
              />
            </Typography>
          
          </div>
  );
}

export default withStyles(styles) (ResourceUsage);



// WEBPACK FOOTER //
// ./src/components/resources/ResourceUsage.js